import { colors } from '@constants/colors';

export const useStyles = (isOffline = false) => {
  return {
    group: {
      marginTop: isOffline ? 1 : 0,
      paddingY: 1,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '&:before': {
        content: '""',
        height: '1px',
        flexGrow: 1,
        backgroundColor: colors.grey_second,
      },
      '&:after': {
        content: '""',
        height: '1px',
        flexGrow: 1,
        backgroundColor: colors.grey_second,
      },
    },
    groupName: {
      fontSize: 14,
      lineHeight: '24px',
      textAlign: 'center',
      color: isOffline ? colors.grey_second : colors.white,
      fontWeight: 500,
      paddingX: 2,
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      marginTop: 1,
    },
  };
};
